import { FieldMissingBucket, KeyBucket } from "generated/graphql";
import { hasIn, PropertyPath } from "lodash";

export type GenericBucket = KeyBucket | FieldMissingBucket;

export const isGenericBucket = (
  maybeBucket: unknown
): maybeBucket is GenericBucket => {
  function check(p: PropertyPath) {
    return hasIn(maybeBucket, p);
  }
  return (
    check("count") &&
    check("__typename") &&
    check("aggregates") &&
    (check("key") || check("fieldMissing"))
  );
};

export const isArrayOfGenericBucket = (
  maybeBucketArray: Array<unknown> | undefined
): maybeBucketArray is Array<GenericBucket> =>
  maybeBucketArray !== undefined && maybeBucketArray.every(isGenericBucket);
